import {
  Component,
  Input,
  QueryList,
  ViewChildren,
  computed,
  inject,
  signal
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import groupBy from 'lodash-es/groupBy';
import { ZefFormElementDirective } from '@zerops/zef/forms';
import { selectObjectStorages, selectObjectStorageDiskGBytesMax } from '@zerops/zerops/core/settings-base';
import {
  ObjectStorageServiceStackFormTranslations
} from './object-storage-service-stack-form.translations';
import { ObjecStorageAcls } from '@zerops/models/service-stack';

@Component({
  selector: 'z-object-storage-service-stack-form',
  templateUrl: './object-storage-service-stack-form.component.html',
  styleUrls: [ './object-storage-service-stack-form.component.scss' ]
})
export class ObjectStorageServiceStackFormComponent {
  #store = inject(Store);
  #projectLocationId = signal<string | undefined>(undefined);

  @Input()
  state: any;

  @Input()
  set projectLocationId(v: string | undefined) {
    this.#projectLocationId.set(v);
  }

  @Input()
  isZen: boolean;

  @Input()
  translations: ObjectStorageServiceStackFormTranslations;

  @ViewChildren(ZefFormElementDirective)
  formElementsRefs: QueryList<ZefFormElementDirective>;

  acls = ObjecStorageAcls;
  aclItems = [
    {
      id: ObjecStorageAcls.PublicRead,
      name: 'Public read'
    },
    {
      id: ObjecStorageAcls.PublicObjectsRead,
      name: 'Public objects read'
    },
    {
      id: ObjecStorageAcls.PublicReadWrite,
      name: 'Public read write'
    },
    {
      id: ObjecStorageAcls.PublicWrite,
      name: 'Public write'
    },
    {
      id: ObjecStorageAcls.Private,
      name: 'Private'
    },
    {
      id: ObjecStorageAcls.Custom,
      name: 'Custom policy'
    }
  ];

  aclItemsVisible = this.aclItems.filter((itm) => itm.id !== ObjecStorageAcls.Custom);

  objectStorages = toSignal(this.#store.select(selectObjectStorages), { initialValue: [] });
  objectStorageGroups = computed(() => Object.entries(groupBy(this.objectStorages(), 'locationName')));
  // the API picks the default of the project location when `location` is not sent,
  // so that one is represented by an empty value
  defaultObjectStorageName = computed(() => this.objectStorages().find(
    (itm) => itm.isDefault && itm.locationId === this.#projectLocationId()
  )?.name);

  diskGBytesMax = toSignal(this.#store.select(selectObjectStorageDiskGBytesMax));

  aclMap = this.aclItems.reduce((obj, itm) => {
    obj[itm.id] = itm.name;
    return obj;
  }, {});

}
